module.exports = __webpack_public_path__ + "videos/38.7fcf6ee.mp4";